var modal;

modal = function(title, desc, modalAction) {
  var $, descField, module, titleField;
  $ = require('jquery');
  module = $(".layout--response");
  titleField = module.find("[data-res='title']");
  descField = module.find("[data-res='description']");
  titleField.html(title);
  descField.html(desc);
  module.addClass('layout--enabled');
  if (modalAction === true) {
    return module.siblings('.layout').removeClass('layout--enabled');
  }
};

module.exports = modal;
